var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.5a2.5 2.5 0 1 0 0-5.001A2.5 2.5 0 0 0 9 11.5ZM9 2c3.86 0 7 3.13 7 7 0 5.25-7 13-7 13S2 14.25 2 9a7 7 0 0 1 7-7Zm6 15h3v-3h2v3h3v2h-3v3h-2v-3h-3v-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddLocation);
export default __webpack_public_path__ + "static/media/icon_add_location.aaf104867bc461cfc8b46e10207761ad.svg";
export { ForwardRef as ReactComponent };